<template>
  <v-container fluid>
    <v-card class="elevation-2 py-0 px-2 mt-4 rounded-lg">
      <v-row class="px-4 pb-0 pt-3">
        <v-col cols="2" sm="2"><v-select v-model="source" :items="['SendPulse','SendInBlue']" outlined dense label="Source"></v-select></v-col>
        <v-col cols="10" sm="5" class="pb-0" style="padding-bottom: 20px!important">
          <v-text-field
              dense
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
              outlined
          ></v-text-field>
          <v-spacer></v-spacer>
        </v-col>
        <v-btn 
          color="#3F51B5" 
          class="mt-3" 
          dark 
          depressed 
          height='40'
          max-width='40'
          min-width='40'
          @click="cleanFilters"
        >
            <v-icon>
                mdi-autorenew
            </v-icon>
        </v-btn>
      </v-row>
    </v-card>
    <v-card class="elevation-2 py-1 px-0 mt-4 rounded-lg">
      <v-card-title>
        <v-row class="pa-0">                
          <v-col cols="12" class="d-flex justify-end pb-0 pt-0 mt-0 mt-md-4">
            <v-spacer></v-spacer>
            <vue-excel-xlsx
              :data="dataForExcel"
              :columns="columnsData"
              :filename="source + ' Report'"
              :sheetname="source + ' Report'"
            >
              <v-btn
                height="39"           
                min-width="39px"        
                :disabled="data.length === 0"
                class="ml-auto mr-5 rounded-lg px-0"                           
                color="white"
              >
                <ExportExcel />
              </v-btn> 
            </vue-excel-xlsx>
            <CustomColumns
              :currentValue="value"
              :currentCustomHeader="customHeader"
              :currentHeaders="headers"
              :settingsName="settingsName"
              @getCustomData="getCustomData"
            />
          </v-col>
        </v-row>
      </v-card-title> 
      <v-hover v-model="hoverOnTable">
        <v-card-text>
          <div class="d-flex justify-space-between nav">
            <v-btn
                class="mx-2 scroll-btn btn-left-arrow"
                fab
                small
                @click="scrollingLeft"
            >
              <v-icon>
                mdi-arrow-left
              </v-icon>
            </v-btn>
            <v-btn
                class="mx-2 scroll-btn btn-right-arrow"
                fab
                small
                @click="scrollingRight"
            >
              <v-icon>
                mdi-arrow-right
              </v-icon>
            </v-btn>
          </div>
          <v-data-table
              v-model="selected"
              :headers="selectedHeaders"
              :items="data"
              item-key="id"
              class="elevation-0 mt-2 table-main-container"
              fixed-header
              height="538"
              :loading="loaded"
              loading-text="Loading... Please wait"
              :search="search"
              :page.sync="pagination.page"
              :footer-props="{
                'items-per-page-options': [10, 25, 50, 75, 100, -1]
                }"
              @click:row="rowClick"
          >
            <template v-slot:item.name="{ item }">
              <span v-if="source=='SendInBlue'"><a target="_blank" :href="`https://my.sendinblue.com/camp/report/id/`+item.id ">{{ item.name }}</a></span>
              <span v-if="source=='SendPulse'"><a target="_blank" :href="`https://login.sendpulse.com/emailservice/tasks/stat/id/`+item.id ">{{ item.name }}</a></span>
            </template>
            <template v-slot:item.sent_date="{ item }">
              <span v-if="item.sent_date">{{ new Date(item.sent_date).toLocaleString() }}</span>
              <span v-else> - </span>
            </template>
            <template v-slot:item.last_sale_date="{ item }">
              <span v-if="item.last_sale_date" >{{ new Date(item.last_sale_date).toLocaleString() }}</span>
              <span v-else> - </span>
            </template>
            <template v-slot:item.orders_ct="{ item }">
              <a v-if="item.orders_ct>0"  @click="redirectToSalesReport(item)">{{ item.orders_ct }}</a>
              <span v-else>0</span>
            </template>
          </v-data-table>
        </v-card-text>
      </v-hover>
    </v-card>
  </v-container>
</template>

<script>
import axios from '@/api/axios-auth'
import CustomColumns from '@/components/customizing/CustomColumns'
import ExportExcel from '@/components/customizing/ExportExcel'

export default {
  components: {
    CustomColumns,
    ExportExcel
  },
  data() {
    return {
      selected: [],
      search: '',
      source: "SendPulse",
      headers: [
        {text: 'Email Campaign', value: 'name', class: 'black--text'},
        {text: 'Sent Date', value: 'sent_date', class: 'black--text'},
        {text: 'Recipients', value: 'sent_ct', class: 'black--text'},
        {text: 'Openers', value: 'unique_views_ct', class: 'black--text'},
        {text: 'Clickers', value: 'unique_clicks_ct', class: 'black--text'},
        {text: 'Unsubscriptions', value: 'unsubscriptions_ct', class: 'black--text'},
        {text: 'Orders', value: 'orders_ct', class: 'black--text'},
        {text: 'Last Sale Date', value: 'last_sale_date', class: 'black--text'},
      ],
      customHeader: ['name', 'sent_date', 'sent_ct', 'unique_views_ct', 'unique_clicks_ct', 'unsubscriptions_ct',
        'orders_ct', 'last_sale_date'],
      selectedHeaders: [],
      value: [
        {text: 'Email Campaign', value: 'name', class: 'black--text'},
        {text: 'Sent Date', value: 'sent_date', class: 'black--text'},
        {text: 'Recipients', value: 'sent_ct', class: 'black--text'},
        {text: 'Openers', value: 'unique_views_ct', class: 'black--text'},
        {text: 'Clickers', value: 'unique_clicks_ct', class: 'black--text'},
        {text: 'Unsubscriptions', value: 'unsubscriptions_ct', class: 'black--text'},
        {text: 'Orders', value: 'orders_ct', class: 'black--text'},
        {text: 'Last Sale Date', value: 'last_sale_date', class: 'black--text'},
      ],
      settingsName: 'sendInBlueReportV2',
      data: [],
      dataOrigin: [],
      columnsData: [],
      selectedRows: [],
      userName: null,
      loaded: false,
      dialogCustomColumns: false,
      scrollLeft: 0,
      scrollWidth: 0,
      clientWidth: 0,
      hoverOnTable: false,
      pagination: {
        page: 1
      }
    }
  },
  watch: {
    data() {
      this.pagination.page = 1
    },
    source(){
      this.applyFilters()
    },
    value(val) {
      this.selectedHeaders = val
      this.getHeaderForExcel()
    },
    hoverOnTable(){
      this.showScrollingArrows()
    }
  },
  created() {
    this.selectedHeaders = this.value
    this.getHeaderForExcel()
    window.addEventListener("resize", this.showScrollingArrows)
  },
  destroyed() {
    window.removeEventListener("resize", this.showScrollingArrows)
  },
  mounted() {

    axios
        .get('/username')
        .then(response => (this.userName = response.data))

    let userName = localStorage.getItem('username')
    let settings = this.settingsName
    let clientId = (localStorage.getItem('ClientId')) ? localStorage.getItem('ClientId') : 1
    if (localStorage.getItem(`${userName}.${clientId}.${settings}`)) {

      try {

        let valueCash = JSON.parse(localStorage.getItem(`${userName}.${clientId}.${settings}`))
        this.value = valueCash.filter(e => this.headers.find(item => item.value === e.value))

        const parsed = JSON.stringify(this.value)
        localStorage.setItem(`${userName}.${clientId}.${settings}`, parsed)

        this.customHeader = this.value.map(e => e.value)
      } catch (e) {
        console.log("")
      }
    }

    this.applyFilters()
    this.showScrollingArrows()
  },
  methods: {
    scrollingRight() {
      const el = document.querySelector('.v-data-table__wrapper')

      el.scrollLeft = el.scrollLeft + 50

      const btnRight = document.querySelector('.btn-right-arrow')
      const btnLeft = document.querySelector('.btn-left-arrow')
      btnRight.style.visibility = (this.hoverOnTable && (el.scrollLeft + el.clientWidth != el.scrollWidth)) ? 'visible' : 'hidden'
      btnLeft.style.visibility = this.hoverOnTable ? 'visible' : 'hidden'
    },
    scrollingLeft() {
      const el = document.querySelector('.v-data-table__wrapper')

      el.scrollLeft = el.scrollLeft - 50

      const btnLeft = document.querySelector('.btn-left-arrow')
      const btnRight = document.querySelector('.btn-right-arrow')
      btnLeft.style.visibility = (this.hoverOnTable && (el.scrollLeft != 0)) ? 'visible' : 'hidden'
      btnRight.style.visibility = this.hoverOnTable ? 'visible' : 'hidden'
    },
    showScrollingArrows() {
      const el = document.querySelector('.v-data-table__wrapper')
      this.scrollLeft = el.scrollLeft
      this.scrollWidth = el.scrollWidth
      this.clientWidth = el.clientWidth

      const btnRight = document.querySelector('.btn-right-arrow')
      const btnLeft = document.querySelector('.btn-left-arrow')
      btnRight.style.visibility = (this.hoverOnTable && (this.scrollLeft + this.clientWidth !== this.scrollWidth)) ? 'visible' : 'hidden'
      btnLeft.style.visibility = (this.hoverOnTable && (this.scrollLeft != 0)) ? 'visible' : 'hidden'
    },
    rowClick: function (item, row) {     
      let selectState = (row.isSelected) ? false : true
      row.select(selectState)
    },
    getHeaderForExcel(){
      this.columnsData = this.selectedHeaders.map(e => {
          const obj = {}
          if (e.value !== "actions") {
              obj.label = e.text
              obj.field = e.value
          }
          return obj
      }).filter(value => Object.keys(value).length !== 0)
    },
    applyFilters() {
      this.loaded = true
      axios
          .get(`/reports/` + this.source.toLowerCase())
          .then(response => {
            this.data = response.data.data

            this.loaded = false
          })
    },
    cleanFilters(){
      this.search = ''
    },
    getCustomData({customHeader, value, selectedHeaders}){
      this.customHeader = customHeader
      this.value = value
      this.selectedHeaders = selectedHeaders
    },
    redirectToSalesReport(item){
      let orders = JSON.stringify({report: 'SendInBlueReport',
                                  order_ids: item.order_ids.map(e => +e),
                                  dateStart: new Date(item.start_date).toISOString().substr(0, 10),
                                  dateEnd: new Date(item.end_date).toISOString().substr(0, 10),
                                  defaultPeriod: 9,
                                  search: item.name
                                  })
      localStorage.setItem('orders', orders)
      let routeData = this.$router.resolve({ name: 'sales'})
      window.open(routeData.href, '_blank')
    },
  },
  computed: {
    dataForExcel(){
      if (!this.data) return []
      let data = JSON.parse(JSON.stringify(this.data))
      data.map(e => {
        e.sent_date = (e.sent_date) ? new Date(e.sent_date).toLocaleString() : '-'
        e.last_sale_date = (e.last_sale_date) ? new Date(e.last_sale_date).toLocaleString() : '-'
      })
      return data 
    },    
  }
}
</script>

<style scoped>
  .btn-right-arrow {
    right: 0px;
    top: 70px;
  }

  .btn-left-arrow {
    left: 0px;
    top: 70px;
  }
</style>